(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxsol-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ls-marquee').forEach((marquee) => {
    const window = marquee.querySelector('.ls-marquee__window');
    const track = marquee.querySelector('.ls-marquee__track');
    const groups = track.querySelectorAll('.ls-marquee__group');
    const originals = [...groups[0].children].map((node) => node.cloneNode(true));
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let lastWidth = 0;
    const fit = () => {
      const width = window.clientWidth;
      if (!width) return;
      groups[0].replaceChildren(...originals.map((node) => node.cloneNode(true)));
      if (!reducedMotion.matches) {
        while (groups[0].getBoundingClientRect().width < width) {
          originals.forEach((node) => {
            const copy = node.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            groups[0].append(copy);
          });
        }
      }
      groups[1].replaceChildren(...[...groups[0].children].map((node) => node.cloneNode(true)));
      track.style.setProperty('--marquee-duration', `${groups[0].getBoundingClientRect().width / 28}s`);
      lastWidth = width;
    };
    const resize = new ResizeObserver(() => {
      if (window.clientWidth !== lastWidth) fit();
    });
    resize.observe(window);
    document.fonts.ready.then(fit);
    reducedMotion.addEventListener('change', fit);
    const visibility = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !document.hidden) track.style.removeProperty('animation-play-state');
      else track.style.animationPlayState = 'paused';
    });
    visibility.observe(marquee);
    document.addEventListener('visibilitychange', () => {
      const rect = marquee.getBoundingClientRect();
      if (!document.hidden && rect.bottom > 0 && rect.top < innerHeight) track.style.removeProperty('animation-play-state');
      else track.style.animationPlayState = 'paused';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxsol-day-night"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxsol-day-night')) {
    customElements.define('luxsol-day-night', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.current = 0;
        this.labels = ['Soft daylight', 'Late afternoon', 'Night · lights off', 'Night · lights on'];
        this.scenes = [...this.querySelectorAll('[data-scene]')];
        this.choices = [...this.querySelectorAll('[data-choice]')];
        this.choices.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
      }
      async show(index) {
        if (!this.scenes[index]) return;
        this.requested = index;
        if (index === this.current) return;
        const image = this.scenes[index].querySelector('img');
        const mobileSource = this.scenes[index].querySelector('source[data-srcset]');
        if (mobileSource) {
          mobileSource.srcset = mobileSource.dataset.srcset;
          delete mobileSource.dataset.srcset;
        }
        if (image.dataset.src) {
          image.src = image.dataset.src;
          delete image.dataset.src;
        }
        try { await image.decode(); } catch (error) { if (!image.naturalWidth) return; }
        if (this.requested !== index || !this.isConnected) return;
        if (this.fade) this.fade.cancel();
        const outgoing = this.scenes[this.current];
        const incoming = this.scenes[index];
        this.scenes.forEach(scene => scene.classList.remove('is-active', 'is-previous'));
        outgoing.classList.add('is-previous');
        incoming.classList.add('is-active');
        this.current = index;
        this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        this.querySelector('[data-status]').textContent = this.labels[index];
        this.querySelector('[data-stage]').setAttribute('aria-label', 'Tora pergola — ' + this.labels[index]);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !incoming.animate) {
          outgoing.classList.remove('is-previous');
          return;
        }
        const fade = incoming.animate([{opacity:0},{opacity:1}], {duration:180,easing:'ease-out',fill:'both'});
        this.fade = fade;
        fade.finished.then(() => {
          if (this.fade === fade) {
            outgoing.classList.remove('is-previous');
            this.fade = null;
            fade.cancel();
          }
        }).catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxsol-home-gardens"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lh-garden-marquee').forEach((marquee) => {
    if (marquee.dataset.gardenReady) return;
    marquee.dataset.gardenReady = 'true';
    const track = marquee.querySelector('.lh-garden-marquee__track');
    const group = track.querySelector('.lh-garden-marquee__set');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let touching = false;
    let focused = false;
    const play = () => {
      track.style.animationPlayState = visible && !document.hidden && !motion.matches && !touching && !focused ? 'running' : 'paused';
    };
    const fit = () => {
      track.style.setProperty('--garden-duration', `${Math.max(group.getBoundingClientRect().width / 24, 1)}s`);
    };
    const resize = new ResizeObserver(fit);
    resize.observe(group);
    const visibility = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      play();
    });
    visibility.observe(marquee);
    const hold = () => { touching = true; play(); };
    const release = () => { touching = false; play(); };
    marquee.addEventListener('focusin', () => { focused = true; play(); });
    marquee.addEventListener('focusout', () => { focused = false; play(); });
    marquee.addEventListener('pointerdown', hold);
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    document.addEventListener('visibilitychange', play);
    motion.addEventListener('change', play);
    fit();
    marquee.closest('.shopify-section').addEventListener('shopify:section:unload', () => {
      resize.disconnect(); visibility.disconnect();
      window.removeEventListener('pointerup', release);
      window.removeEventListener('pointercancel', release);
      document.removeEventListener('visibilitychange', play);
      motion.removeEventListener('change', play);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxsol-home-models"] && !Shopify.designMode) return;
  try {
    
  function initModelCarousels(root = document) {
    root.querySelectorAll('.lh-models').forEach((section) => {
      if (section.dataset.carouselReady) return;
      const track = section.querySelector('.lh-model-grid');
      const tabs = section.querySelector('.lh-model-tabs');
      const buttons = [...tabs.querySelectorAll('button')];
      const cards = [...track.querySelectorAll('.lh-model')];
      if (cards.length < 2) return;
      section.dataset.carouselReady = 'true';
      tabs.hidden = false;
      const mobile = matchMedia('(max-width: 749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = index;
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      const cardLeft = (index) => track.scrollLeft + cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
      const select = (index, smooth = true) => {
        setActive(index);
        if (mobile.matches) track.scrollTo({ left: cardLeft(index), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
      };
      const sync = () => {
        frame = 0;
        if (!mobile.matches) return;
        const left = track.getBoundingClientRect().left;
        const distances = cards.map((card) => Math.abs(card.getBoundingClientRect().left - left));
        setActive(distances.indexOf(Math.min(...distances)));
      };
      const onScroll = () => { if (!frame) frame = requestAnimationFrame(sync); };
      const onClick = (event) => {
        const button = event.target.closest('[data-model-index]');
        if (button) select(Number(button.dataset.modelIndex));
      };
      const onKey = (event) => {
        const index = buttons.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        select(next);
        buttons[next].focus({ preventScroll: true });
      };
      const onFocus = (event) => {
        const index = cards.indexOf(event.target.closest('.lh-model'));
        if (mobile.matches && index >= 0 && index !== active) select(index, false);
      };
      const onResize = () => {
        if (mobile.matches) select(active, false);
        else track.scrollLeft = 0;
      };
      tabs.addEventListener('click', onClick);
      tabs.addEventListener('keydown', onKey);
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('focusin', onFocus);
      const resize = new ResizeObserver(onResize);
      resize.observe(track);
      const unload = (event) => {
        if (event.target !== section.closest('.shopify-section')) return;
        resize.disconnect();
        cancelAnimationFrame(frame);
        tabs.removeEventListener('click', onClick);
        tabs.removeEventListener('keydown', onKey);
        track.removeEventListener('scroll', onScroll);
        track.removeEventListener('focusin', onFocus);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  initModelCarousels();
  document.addEventListener('shopify:section:load', (event) => initModelCarousels(event.target));
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.lh-models__intro, .ls-feature-gallery__intro, .lh-real-gardens__intro').forEach((intro) => {
      if (intro.dataset.motionReady) return;
      intro.dataset.motionReady = 'true';
      const targets = intro.querySelectorAll('h2, p');
      const reveal = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          reveal.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -48px 0px', threshold: .12 });
      targets.forEach((target, index) => {
        target.style.setProperty('--text-reveal-delay', `${index * 70}ms`);
        target.classList.add('lh-text-reveal');
        if (target.getBoundingClientRect().bottom <= 0) return;
        target.classList.add('is-pending');
        reveal.observe(target);
      });
      const section = intro.closest('.shopify-section');
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === section) reveal.disconnect();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxsol-system-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxsol-system-builder')) {
    customElements.define('luxsol-system-builder', class extends HTMLElement {
      connectedCallback() {
        this.inputs = Array.from(this.querySelectorAll('[data-quantity]'));
        this.message = this.querySelector('[data-builder-message]');
        this.addButton = this.querySelector('[data-add-system]');
        this.summaryList = this.querySelector('[data-summary-list]');
        this.totalElements = this.querySelectorAll('[data-system-total], [data-button-total]');
        this.variantChoices = Array.from(this.querySelectorAll('[data-variant-choice]'));
        this.sideTabs = Array.from(this.querySelectorAll('[data-side-tab]'));
        this.sideOptions = Array.from(this.querySelectorAll('[data-side-option]'));
        this.normalSideOrder = ['front', 'rear', 'left', 'right'];
        this.splitSideOrder = ['front-1', 'front-2', 'rear-1', 'rear-2', 'left', 'right'];
        this.allSideOrder = ['front', 'rear', 'front-1', 'front-2', 'rear-1', 'rear-2', 'left', 'right'];
        this.sideOrder = [...this.normalSideOrder];
        this.sideLabels = Object.fromEntries(this.sideTabs.map((tab) => [tab.dataset.sideTab, tab.querySelector('strong').textContent.trim()]));
        this.sideSelections = Object.fromEntries(this.allSideOrder.map((side) => [side, null]));
        this.activeSide = 'front';
        this.basePriceDisplay = this.querySelector('[data-base-price-display]');
        this.baseCompare = this.querySelector('[data-base-compare]');
        this.baseSaving = this.querySelector('[data-base-saving]');
        this.stock = this.querySelector('.lsb__stock');
        this.stockLabel = this.querySelector('[data-stock-label]');
        this.accordions = Array.from(this.querySelectorAll('.lsb__details-grid details'));
        this.stepLinks = Array.from(this.querySelectorAll('[data-step-link]'));
        this.steps = Array.from(this.querySelectorAll('[data-builder-step]'));
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: this.dataset.currency,
        });

        const heaterInput = this.querySelector('[data-role="heater"] [data-quantity]');
        if (heaterInput) {
          const heaterItem = heaterInput.closest('[data-builder-item]');
          const heaterQuantity = this.dataset.family === 'tora' ? 2 : 1;
          heaterInput.max = String(heaterQuantity);
          heaterItem.dataset.groupMax = String(heaterQuantity);
        }

        this.accordions.forEach((accordion) => {
          accordion.addEventListener('toggle', () => {
            if (!accordion.open) return;

            this.accordions.forEach((otherAccordion) => {
              if (otherAccordion !== accordion) otherAccordion.open = false;
            });
          });
        });

        this.querySelectorAll('[data-decrement]').forEach((button) => {
          button.addEventListener('click', () => this.adjust(button.closest('[data-builder-item]'), -1));
        });

        this.querySelectorAll('[data-increment]').forEach((button) => {
          button.addEventListener('click', () => this.adjust(button.closest('[data-builder-item]'), 1));
        });

        this.variantChoices.forEach((choice) => {
          choice.addEventListener('click', () => this.selectVariant(choice));
        });

        this.sideTabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectSide(tab.dataset.sideTab));
        });

        this.sideOptions.forEach((option) => {
          option.addEventListener('click', () => this.selectSideOption(option));
        });

        this.querySelector('[data-next-side]')?.addEventListener('click', () => {
          const nextIndex = (this.sideOrder.indexOf(this.activeSide) + 1) % this.sideOrder.length;
          this.selectSide(this.sideOrder[nextIndex]);
        });

        this.stepLinks.forEach((link) => {
          link.addEventListener('click', () => this.setActiveStep(link.dataset.stepLink));
        });

        this.addButton?.addEventListener('click', () => this.addSystem());
        this.configureSides();
        this.update();
      }

      setActiveStep(step) {
        this.stepLinks.forEach((link) => {
          const active = link.dataset.stepLink === step;
          link.classList.toggle('lsb__guide-link--active', active);
          if (active) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
      }

      money(minorUnits) {
        return this.formatter.format(minorUnits / 100);
      }

      dimensions() {
        const match = this.dataset.baseTitle.match(/(\d+(?:\.\d+)?)\s*m?\s*[x×]\s*(\d+(?:\.\d+)?)\s*m?/i);
        const values = match ? [Number(match[1]), Number(match[2])] : [3, 3];
        return { front: Math.max(...values), side: Math.min(...values) };
      }

      sideLength(side) {
        const dimensions = this.dimensions();
        if (dimensions.front === 8 && this.dataset.family === 'tora') return '4m';
        const edge = side.split('-')[0];
        return `${edge === 'front' || edge === 'rear' ? dimensions.front : dimensions.side}m`;
      }

      optionFits(option, length) {
        if (option.dataset.kind === 'open') return true;
        if (this.dataset.family === 'aura' && option.dataset.kind === 'electric') return false;
        if (option.dataset.length !== length) return false;
        if (length === '3m' || length === '4m') return true;
        return option.dataset.kind === 'electric';
      }

      configureSides() {
        const useSplitSides = this.dataset.family === 'tora' && this.dimensions().front === 8;
        const nextOrder = useSplitSides ? this.splitSideOrder : this.normalSideOrder;
        const layoutChanged = nextOrder.join(',') !== this.sideOrder.join(',');

        if (layoutChanged && useSplitSides) {
          this.sideSelections['front-1'] = this.sideSelections.front;
          this.sideSelections['front-2'] = this.sideSelections.front;
          this.sideSelections['rear-1'] = this.sideSelections.rear;
          this.sideSelections['rear-2'] = this.sideSelections.rear;
          this.sideSelections.front = null;
          this.sideSelections.rear = null;
        } else if (layoutChanged) {
          this.sideSelections.front = this.sideSelections['front-1'] === this.sideSelections['front-2'] ? this.sideSelections['front-1'] : null;
          this.sideSelections.rear = this.sideSelections['rear-1'] === this.sideSelections['rear-2'] ? this.sideSelections['rear-1'] : null;
          this.splitSideOrder.forEach((side) => {
            if (side.includes('-')) this.sideSelections[side] = null;
          });
        }

        this.sideOrder = [...nextOrder];
        if (!this.sideOrder.includes(this.activeSide)) this.activeSide = this.sideOrder[0];
        this.sideTabs.forEach((tab) => {
          tab.hidden = !this.sideOrder.includes(tab.dataset.sideTab);
        });
        this.sideOrder.forEach((side) => {
          const selection = this.sideSelections[side];
          if (selection && !this.optionFits(selection, this.sideLength(side))) this.sideSelections[side] = null;
        });
        this.selectSide(this.activeSide, false);
      }

      selectSide(side, shouldFocus = true) {
        this.activeSide = side;
        const length = this.sideLength(side);
        const selection = this.sideSelections[side];

        this.sideTabs.forEach((tab) => {
          const active = tab.dataset.sideTab === side;
          tab.classList.toggle('lsb-side-tab--active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        const heading = this.querySelector('[data-active-side-title]');
        const lengthBadge = this.querySelector('[data-active-side-length]');
        if (heading) heading.textContent = this.sideLabels[side];
        if (lengthBadge) lengthBadge.textContent = `${length} ${this.dataset.sideOpeningLabel}`;

        this.sideOptions.forEach((option) => {
          const fits = this.optionFits(option, length);
          option.hidden = !fits;
          const selected = selection ? option === selection : option.dataset.kind === 'open';
          option.classList.toggle('lsb-side-choice--selected', selected);
          option.setAttribute('aria-checked', String(selected));
          option.dataset.sideQuantity = '1';
          if (option.dataset.kind !== 'open') {
            const price = option.querySelector('small');
            if (price) price.textContent = `+ ${this.money(Number(option.dataset.price) * Number(option.dataset.sideQuantity))}`;
          }
        });

        const nextButton = this.querySelector('[data-next-side]');
        const nextIndex = (this.sideOrder.indexOf(side) + 1) % this.sideOrder.length;
        if (nextButton) nextButton.textContent = `${this.dataset.sideNextLabel}: ${this.sideLabels[this.sideOrder[nextIndex]]} →`;
        if (shouldFocus) heading?.focus?.({ preventScroll: true });
      }

      selectSideOption(option) {
        if (option.disabled || option.hidden) return;
        this.sideSelections[this.activeSide] = option.dataset.kind === 'open' ? null : option;
        this.showMessage('');
        this.selectSide(this.activeSide, false);
        this.update();
      }

      selectVariant(choice) {
        const price = Number(choice.dataset.variantPrice);
        const comparePrice = Number(choice.dataset.variantComparePrice);
        const available = choice.dataset.variantAvailable === 'true';

        this.dataset.baseVariantId = choice.dataset.variantId;
        this.dataset.basePrice = String(price);
        this.dataset.baseTitle = `${this.dataset.productTitle} · ${choice.dataset.variantTitle}`;

        this.variantChoices.forEach((candidate) => {
          const selected = candidate === choice;
          candidate.classList.toggle('lsb-choice--selected', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });

        this.basePriceDisplay.textContent = this.money(price);
        if (comparePrice > price) {
          this.baseCompare.textContent = this.money(comparePrice);
          this.baseSaving.textContent = choice.dataset.variantSavingLabel;
          this.baseCompare.hidden = false;
          this.baseSaving.hidden = false;
        } else {
          this.baseCompare.hidden = true;
          this.baseSaving.hidden = true;
        }

        this.stock.classList.toggle('lsb__stock--unavailable', !available);
        this.stockLabel.textContent = choice.dataset.stockLabel;
        this.addButton.disabled = !available;
        this.showMessage('');
        this.configureSides();
        this.update();
      }

      adjust(item, delta) {
        const input = item.querySelector('[data-quantity]');
        if (!input || input.disabled) return;

        const current = Number(input.value);
        const increment = item.dataset.role === 'heater' && this.dataset.family === 'tora' ? 2 : 1;
        const next = Math.max(Number(input.min), Math.min(Number(input.max), current + (delta * increment)));
        const group = item.dataset.group;
        const groupMax = Number(item.dataset.groupMax || input.max);
        const groupTotal = this.inputs
          .filter((candidate) => candidate.closest('[data-builder-item]').dataset.group === group)
          .reduce((total, candidate) => total + Number(candidate.value), 0);

        if (delta > 0 && groupTotal >= groupMax) {
          this.showMessage(this.dataset.limitError);
          return;
        }

        input.value = String(next);
        if (item.dataset.role === 'installation' && next === 0) {
          const dependent = this.querySelector('[data-requires="installation"] [data-quantity]');
          if (dependent) dependent.value = '0';
        }
        this.showMessage('');
        this.update();
      }

      update() {
        const installationSelected = this.inputs.some((input) => {
          const item = input.closest('[data-builder-item]');
          return item.dataset.role === 'installation' && Number(input.value) > 0;
        });

        this.inputs.forEach((input) => {
          const item = input.closest('[data-builder-item]');
          const requiresInstallation = item.dataset.requires === 'installation';
          if (requiresInstallation) {
            input.disabled = !installationSelected;
            if (!installationSelected) input.value = '0';
          }
          item.classList.toggle('lsb-option--selected', Number(input.value) > 0);
        });

        const basePrice = Number(this.dataset.basePrice);
        let total = basePrice;
        const rows = [{ title: this.dataset.baseTitle, quantity: 1, price: basePrice }];

        this.sideOrder.forEach((side) => {
          const option = this.sideSelections[side];
          const status = this.querySelector(`[data-side-status="${side}"]`);
          if (!option) {
            if (status) status.textContent = this.dataset.sideOpenLabel;
            return;
          }

          const quantity = 1;
          const price = Number(option.dataset.price) * quantity;
          total += price;
          const optionName = option.querySelector('strong')?.textContent.trim() || option.dataset.productTitle;
          if (status) status.textContent = optionName;
          rows.push({ title: `${this.sideLabels[side]} · ${quantity > 1 ? `${quantity} × ` : ''}${optionName} (${this.sideLength(side)})`, quantity: 1, price });
        });

        const fittedCount = this.sideOrder.filter((side) => this.sideSelections[side]).length;
        const progress = this.querySelector('[data-side-progress]');
        if (progress) progress.textContent = `${fittedCount} of ${this.sideOrder.length} ${this.dataset.sideFittedLabel}`;

        this.inputs.forEach((input) => {
          const quantity = Number(input.value);
          if (quantity > 0) {
            const price = Number(input.dataset.price);
            total += price * quantity;
            rows.push({ title: input.dataset.productTitle, quantity, price: price * quantity });
          }
        });

        this.summaryList.replaceChildren(...rows.map((row) => {
          const item = document.createElement('li');
          const title = document.createElement('span');
          const price = document.createElement('strong');
          title.textContent = row.quantity > 1 ? `${row.quantity} × ${row.title}` : row.title;
          price.textContent = this.money(row.price);
          item.append(title, price);
          return item;
        }));

        this.totalElements.forEach((element) => {
          element.textContent = this.money(total);
        });

        this.querySelectorAll('[data-builder-item]').forEach((item) => {
          const input = item.querySelector('[data-quantity]');
          const decrement = item.querySelector('[data-decrement]');
          const increment = item.querySelector('[data-increment]');
          const group = item.dataset.group;
          const groupMax = Number(item.dataset.groupMax || input.max);
          const groupTotal = this.inputs
            .filter((candidate) => candidate.closest('[data-builder-item]').dataset.group === group)
            .reduce((sum, candidate) => sum + Number(candidate.value), 0);
          decrement.disabled = input.disabled || Number(input.value) <= Number(input.min);
          increment.disabled = input.disabled || Number(input.value) >= Number(input.max) || groupTotal >= groupMax;
        });
      }

      showMessage(text) {
        this.message.textContent = text;
      }

      async addSystem() {
        const items = [{
          id: Number(this.dataset.baseVariantId),
          quantity: 1,
          properties: { '_LuxSol system': this.dataset.baseTitle },
        }];

        this.sideOrder.forEach((side) => {
          const option = this.sideSelections[side];
          if (!option) return;
          items.push({
            id: Number(option.dataset.variantId),
            quantity: 1,
            properties: {
              '_LuxSol system': this.dataset.baseTitle,
              'Side position': this.sideLabels[side],
              'Opening': this.sideLength(side),
            },
          });
        });

        this.inputs.forEach((input) => {
          const quantity = Number(input.value);
          if (quantity > 0 && !input.disabled) {
            items.push({
              id: Number(input.dataset.variantId),
              quantity,
              properties: { '_LuxSol system': this.dataset.baseTitle },
            });
          }
        });

        this.addButton.disabled = true;
        this.addButton.classList.add('lsb__add--loading');
        const label = this.addButton.querySelector('[data-add-label]');
        const originalLabel = label.textContent;
        label.textContent = this.dataset.loadingLabel;
        this.showMessage('');
        const transport = document.createElement('iframe');
        transport.hidden = true;
        transport.setAttribute('aria-hidden', 'true');
        document.body.appendChild(transport);

        try {
          const isolatedFetch = transport.contentWindow.fetch.bind(transport.contentWindow);
          const response = await isolatedFetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || this.dataset.cartError);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.showMessage(error.message || this.dataset.cartError);
          this.addButton.disabled = false;
          this.addButton.classList.remove('lsb__add--loading');
          label.textContent = originalLabel;
        } finally {
          transport.remove();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
